/*
 * Pijltjes, teller en toetsenbord voor de grote fotoviewer op een productpagina.
 *
 * Het thema zet de foto's in de viewer in één lange rol. De opmaak
 * (component-km-fotoviewer.css) legt ze naast elkaar met één foto per beeld;
 * dit script zet daar de knoppen bij en houdt de teller bij.
 */
(function () {
  var PIJL_LINKS = '‹';
  var PIJL_RECHTS = '›';

  function maakKnop(klasse, tekst, label) {
    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'km-fotoviewer__pijl ' + klasse;
    knop.textContent = tekst;
    knop.setAttribute('aria-label', label);
    return knop;
  }

  function bouw(modal) {
    if (modal.dataset.kmViewer === 'klaar') return;
    modal.dataset.kmViewer = 'klaar';

    var rol = modal.querySelector('.product-media-modal__content');
    var dialoog = modal.querySelector('.product-media-modal__dialog');
    if (!rol || !dialoog) return;

    // Het thema sluit deze viewer bij élke muisklik erin (media-modal doet een
    // pointerup-afhandeling op zichzelf). Daardoor ging de viewer dicht als je op
    // een pijltje of op de foto klikte. Klikken binnen het venster mag dus niet
    // doorgegeven worden; klikken op de donkere waas eromheen wél, want zo klik je
    // de viewer weg.
    modal.addEventListener(
      'pointerup',
      function (event) {
        if (event.target.closest('.product-media-modal__dialog')) event.stopPropagation();
      },
      true
    );

    var items = rol.children;
    if (items.length < 2) return; // bij één foto zijn knoppen zinloos

    var vorige = maakKnop('km-fotoviewer__pijl--vorige', PIJL_LINKS, 'Vorige foto');
    var volgende = maakKnop('km-fotoviewer__pijl--volgende', PIJL_RECHTS, 'Volgende foto');
    var teller = document.createElement('p');
    teller.className = 'km-fotoviewer__teller';

    // De knoppen komen ónder de foto te staan, met de teller ertussen.
    var balk = document.createElement('div');
    balk.className = 'km-fotoviewer__balk';
    balk.appendChild(vorige);
    balk.appendChild(teller);
    balk.appendChild(volgende);
    dialoog.appendChild(balk);

    function huidig() {
      return Math.round(rol.scrollLeft / rol.clientWidth);
    }

    function werkBij() {
      var nu = huidig();
      teller.textContent = nu + 1 + ' van ' + items.length;
      vorige.disabled = nu <= 0;
      volgende.disabled = nu >= items.length - 1;
    }

    function ga(richting) {
      rol.scrollTo({ left: (huidig() + richting) * rol.clientWidth, behavior: 'smooth' });
    }

    vorige.addEventListener('click', function () {
      ga(-1);
    });
    volgende.addEventListener('click', function () {
      ga(1);
    });
    rol.addEventListener('scroll', function () {
      window.clearTimeout(rol.kmTimer);
      rol.kmTimer = window.setTimeout(werkBij, 80);
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        ga(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        ga(-1);
      }
    });

    werkBij();
  }

  function start() {
    document.querySelectorAll('product-modal').forEach(bouw);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
